module.exports = __webpack_public_path__ + "static/media/play.ede1d5ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/play.svg
// module id = 447
// module chunks = 0